import { Outlet } from "react-router-dom";

import { Processes } from "@src/components/MainApp/Alerts/Processes";
import { NavigationDrawer } from "@src/components/Navigation/BaseSideNav/NavigationDrawer";
import { IgPageContent } from "@src/utils/IgPageContent";

import { AlertBanner } from "./alerts/AlertBanner";
import { AppLayoutShell } from "./layout/AppLayoutShell";

export const StandardPageProvider = () => {
  // Seasonal: snowfall image assets (uncomment during winter holidays)
  // const snowflake1 = document.createElement("img");
  // snowflake1.src = snowflakeImg;
  //
  // const images = [snowflake1];

  // Seasonal: Christmas lights toggle (uncomment during winter holidays)
  // const hideLights = useMemo(() => Cookies.get("hideLights"), []);
  // useEffect(() => {
  //   window["hideLights"] = () => {
  //     Cookies.set("hideLights", "true", { expires: 365 });
  //     window.location.reload();
  //   };
  // }, []);

  return (
    <AppLayoutShell
      banner={<AlertBanner />}
      sideNav={<NavigationDrawer isUnauthorized={false} />}
      maxWidth={1600}
    >
      {/* Seasonal: Christmas garland decoration (uncomment during winter holidays) */}
      {/*{hideLights ? null : (*/}
      {/*  <Suspense fallback={null}>*/}
      {/*    <ChristmasGarland position="-1435px" />*/}
      {/*    <ChristmasGarland position="-135px" />*/}
      {/*    <ChristmasGarland position="1165px" />*/}
      {/*  </Suspense>*/}
      {/*)}*/}
      {/* Seasonal: snowfall effect replaces confetti during winter holidays.
          Reads state.global.confetti and mounts alongside AppConfetti. */}
      {/*{confetti && (*/}
      {/*  <Suspense fallback={null}>*/}
      {/*    <Snowfall*/}
      {/*      snowflakeCount={350}*/}
      {/*      images={images}*/}
      {/*      radius={[8, 23]}*/}
      {/*      speed={[2, 4.5]}*/}
      {/*      style={{*/}
      {/*        zIndex: 1000,*/}
      {/*      }}*/}
      {/*    />*/}
      {/*  </Suspense>*/}
      {/*)}*/}
      <IgPageContent>
        <Processes />
        <Outlet />
      </IgPageContent>
    </AppLayoutShell>
  );
};
